import * as i2 from '@angular/cdk/overlay';
import { OverlayModule } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import * as i0 from '@angular/core';
import { InjectionToken, Directive, Inject, Input, NgModule } from '@angular/core';
import * as i1 from '@fleetmatics/ui.help-panel/shared';

/*!
 * Copyright © 2020. Verizon Connect Ireland Limited. All rights reserved.
 */
const HELP_PANEL_WRAPPER_LOADER = new InjectionToken('helpPanelWrapper');
class HelpPanelConnectorDirective {
    set hlpConnectorArticleLabel(article) {
        this.helpPanelSharedService.featuredArticlesLabel = article;
    }
    constructor(helpPanelWrapper, helpPanelSharedService, overlay) {
        this.helpPanelWrapper = helpPanelWrapper;
        this.helpPanelSharedService = helpPanelSharedService;
        this.overlay = overlay;
        this.toggled$ = this.helpPanelSharedService.toggled$;
    }
    async toggle(on) {
        if (on == null) {
            const currentState = await this.helpPanelSharedService.toggled$.toPromise();
            this.helpPanelSharedService.toggle(!currentState);
            return;
        }
        this.helpPanelSharedService.toggle(on);
    }
    listenForHelpPanelToggle() {
        this.helpPanelSubscription = this.helpPanelSharedService.toggled$.subscribe(async (on) => {
            if (on) {
                if (!this.componentPortal) {
                    this.componentPortal = await this.createComponentPortal();
                }
                if (!this.overlayRef) {
                    this.overlayRef = this.createOverlay();
                }
                this.overlayRef.attach(this.componentPortal);
            }
            else {
                this.overlayRef?.detach();
            }
        });
    }
    ngOnInit() {
        this.listenForHelpPanelToggle();
    }
    ngOnDestroy() {
        if (this.helpPanelSubscription) {
            this.helpPanelSubscription.unsubscribe();
        }
    }
    async createComponentPortal() {
        const componentEsm = await this.helpPanelWrapper();
        const componentKey = Object.keys(componentEsm)[0];
        const component = componentEsm[componentKey];
        return new ComponentPortal(component);
    }
    createOverlay() {
        const position = this.overlay.position().global().right('16px').top('96px');
        const config = {
            positionStrategy: position,
            height: '573px',
            width: '300px',
        };
        return this.overlay.create(config);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: HelpPanelConnectorDirective, deps: [{ token: HELP_PANEL_WRAPPER_LOADER }, { token: i1.HelpPanelSharedService }, { token: i2.Overlay }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: HelpPanelConnectorDirective, selector: "[hlpConnector]", inputs: { hlpConnectorArticleLabel: "hlpConnectorArticleLabel" }, exportAs: ["hlpConnector"], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: HelpPanelConnectorDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[hlpConnector]',
                    exportAs: 'hlpConnector',
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [HELP_PANEL_WRAPPER_LOADER]
                }] }, { type: i1.HelpPanelSharedService }, { type: i2.Overlay }]; }, propDecorators: { hlpConnectorArticleLabel: [{
                type: Input
            }] } });

/*!
 * Copyright © 2020. Verizon Connect Ireland Limited. All rights reserved.
 */
class HelpPanelConnectorModule {
    static forRoot(helpPanelWrapper) {
        return {
            ngModule: HelpPanelConnectorModule,
            providers: [{ provide: HELP_PANEL_WRAPPER_LOADER, useValue: helpPanelWrapper }],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: HelpPanelConnectorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: HelpPanelConnectorModule, declarations: [HelpPanelConnectorDirective], imports: [OverlayModule], exports: [HelpPanelConnectorDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: HelpPanelConnectorModule, imports: [OverlayModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: HelpPanelConnectorModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [OverlayModule],
                    declarations: [HelpPanelConnectorDirective],
                    exports: [HelpPanelConnectorDirective],
                }]
        }] });

/*!
 * Copyright © 2020. Verizon Connect Ireland Limited. All rights reserved.
 */

/*!
 * Copyright © 2020. Verizon Connect Ireland Limited. All rights reserved.
 */

/**
 * Generated bundle index. Do not edit.
 */

export { HELP_PANEL_WRAPPER_LOADER, HelpPanelConnectorDirective, HelpPanelConnectorModule };
